import { IframeMessageProxy } from 'iframe-message-proxy';

export const sendCommand = (command, timeout = 60000, destination = 'BlipService') => {
  return IframeMessageProxy.sendMessage({
    action: 'sendCommand',
    content: {
      command,
      timeout,
      destination,
    },
  });
};

export const BlipApi = {
  sendCommand,
};
